import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button, ShortModal } from '@sbt-web/ui';
import { PrivateUserCompletedDealsCounterProps } from './types';
export const PrivateUserCompletedDealsCounter = t0 => {
  const $ = _c(20);
  const {
    dealsDone,
    buttonClassName,
    labelClassName,
    counterClassName
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  if (!dealsDone) {
    return;
  }
  const t1 = buttonClassName ?? "";
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsModalOpen(true);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== counterClassName || $[4] !== dealsDone) {
    t4 = <span className={counterClassName}>{dealsDone}</span>;
    $[3] = counterClassName;
    $[4] = dealsDone;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = dealsDone === 1 ? "Affare concluso" : "Affari conclusi";
  let t6;
  if ($[6] !== labelClassName || $[7] !== t5) {
    t6 = <p className={labelClassName}>{t5}</p>;
    $[6] = labelClassName;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t6) {
    t7 = <Button design="text" classes={t2} onClick={t3}>{t4}{t6}</Button>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsModalOpen(false);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      main: {
        text: "Ok, ho capito",
        design: "text",
        action: () => {
          setIsModalOpen(false);
        }
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isModalOpen) {
    t10 = <ShortModal open={isModalOpen} onClose={t8} title="Gli affari conclusi su Subito" hasCloseButton={true} buttonConfiguration={t9}>Il numero di affari conclusi include tutte le transazioni completate su Subito, indipendentemente dalla presenza di una recensione. Questo assicura un conteggio più accurato delle transazioni concluse.</ShortModal>;
    $[15] = isModalOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <>{t7}{t10}</>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};